<template>
    <div>
        <v-container fluid class="pb-0 primary" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}" v-if="1==0">
                <v-row align="center">
                    <v-col cols="12" sm="12" md="6">
                        <h1 class="mb-4 black--text">Hello
                            <span v-if="userInfo">
                                {{ userInfo.name }}
                            </span>
                        </h1>
                        <h2 class="font-weight-regular black--text">We've got you covered!</h2>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" class="pb-0 hidden-sm-and-down text-right">
                        <svg width="200" height="200" viewBox="0 0 200 200" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M89.2499 119.375C82.5001 111.208 72.2502 106.042 60.8336 106.042C54.4168 106.042 48.3336 107.708 43.0836 110.625C39.8335 112.292 36.917 114.542 34.4166 117.125C27.834 123.875 23.7507 132.958 23.7507 143.125C23.7507 163.542 40.334 180.125 60.8336 180.125C70.8332 180.125 79.8339 176.208 86.4174 169.875C93.4999 163.125 97.9166 153.625 97.9166 143.125C97.9166 134.042 94.6674 125.792 89.2499 119.375ZM61.8336 162.458L42.9167 149.625C40.5842 148.125 40.0003 145.042 41.4997 142.708C42.5007 141.292 44.0002 140.542 45.583 140.542C46.584 140.458 47.5829 140.792 48.5005 141.375L59.7502 148.958L75.417 128.875C77.1666 126.708 80.3333 126.292 82.5001 128.042C84.6666 129.708 84.9999 132.875 83.3332 135.042L64.333 159.292L61.8336 162.458Z"
                                  fill="#000" fill-opacity="0.8"/>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M31.5002 96.3749C31.5002 54.2083 65.8335 19.875 108.083 19.875C150.25 19.875 184.583 54.2083 184.583 96.3749C184.583 116.292 176.917 135.208 163.084 149.625C148.584 164.625 129 172.958 108.083 172.958C103.917 172.958 99.8333 172.625 95.75 172.042C102.25 164.208 106.167 154.125 106.167 143.125C106.167 133.792 103.333 125.042 98.5008 117.792C98.9175 117.708 99.25 117.708 99.6667 117.708H116.417C131.417 117.708 147.167 128.125 156.667 141.792C168.167 129.375 174.583 113.292 174.583 96.3749C174.583 59.7081 144.751 29.8751 108.083 29.8751C71.3338 29.8751 41.4998 59.7081 41.4998 96.3749C41.4998 98.2083 41.5832 100.125 41.8335 101.958C38.4176 103.458 35.3332 105.375 32.4167 107.792C31.7505 104.042 31.5002 100.208 31.5002 96.3749ZM107.998 49.0417C124.416 49.0417 137.749 62.3748 137.749 78.7918C137.749 95.2916 124.416 108.542 107.998 108.542C91.5825 108.542 78.2491 95.2916 78.2491 78.7918C78.2491 62.3748 91.5825 49.0417 107.998 49.0417Z"
                                  fill="#000" fill-opacity="0.5"/>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M86.4174 169.874L69.4927 152.706L64.333 159.291L61.8336 162.458L42.9167 149.625C40.5842 148.124 40.0003 145.041 41.4997 142.708C42.5007 141.292 44.0002 140.541 45.583 140.541C46.584 140.458 47.5829 140.792 48.5005 141.374L59.7502 148.958L62.4218 145.533L34.4166 117.124C27.834 123.874 23.7507 132.958 23.7507 143.124C23.7507 163.541 40.334 180.124 60.8336 180.124C70.8332 180.124 79.8339 176.208 86.4174 169.874Z"
                                  fill="#000" fill-opacity="0.8"/>
                        </svg>


                    </v-col>
                </v-row>
            </v-container>
        <v-container fluid class="primary py-0 hidden-sm-and-down mt-6">
            
            <v-container fluid class="pb-0" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}" v-if="1==0">
                <v-row align="center">
                    <v-col cols="12" sm="12" md="6">
                        <h1 class="mb-4 black--text">
                            My Appointments
                        </h1>
                        <!--                        <h2 class="font-weight-regular">My Appointments</h2>-->
                    </v-col>
                    <v-col cols="12" sm="12" md="6" class="pb-0">

                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <v-container fluid class="pt-0" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}">
            <v-row v-if="userInfo">
                <v-col cols="12" sm="12" md="7" class="hidden-md-and-up">
                    <h2>My Appointments</h2>
                </v-col>
                <v-col cols="12" sm="12" :md="appointmentsList.length ? 7 : 12" class="pt-0">
                    <v-row class="hidden-sm-and-down">
                        <v-col cols="12" sm="12">
                            <v-card outlined>
                                <v-card-text>
                                    <v-row class="pb-0" dense>
                                        <v-col cols="12" sm="12" md="5" class="pb-0">
                                            <v-select 
                                                v-model="appointmentFilter" 
                                                solo flat 
                                                class="solo-bordered"
                                                :items="appointmentFilters"
                                                item-text="text"
                                                item-value="value"
                                                item-color="darkPrimary"
                                            >
                                            </v-select>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col cols="12" sm="12" md="5" class="pb-0">
                                            <v-text-field
                                            v-model="search"
                                            label="Search" 
                                            solo flat 
                                            class="solo-bordered"
                                            prepend-inner-icon="mdi-magnify"></v-text-field>
                                        </v-col>
                                    </v-row>


                                    <v-simple-table v-if="!loadingAppointments">
                                            
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">Date</th>
                                                <th class="text-left">Appointment Time</th>
                                                <th class="text-left">Doctor</th>
                                                <th class="text-left">Type</th>
                                                <th class="text-left">Status</th>
                                            </tr>
                                            </thead>
                                            
                                            <tbody>                                                
                                            <tr 
                                                v-for="appointment in appointmentsList" 
                                                :key="appointment.id+'main'" 
                                                :style="appointment.id == appointmentDetails.id ? 'background:#eeeeee;' : 'background:white;'"
                                                @click="appointmentDetails = appointment" 
                                                :class="{'grey lighten-3' : appointmentDetails === appointment}" 
                                                class="pointer"
                                            >
                                                <td style="padding: 12px">
                                                    <v-avatar color="grey lighten-2" size="40" tile>
                                                        <b>
                                                            {{ dateutils.utcToLocal(appointment.start_time).format('DD') }}
                                                            <br>
                                                            {{ dateutils.utcToLocal(appointment.start_time).format('MMM') }}
                                                        </b>
                                                    </v-avatar>
                                                </td>
                                                <td>{{ dateutils.utcToLocal(appointment.start_time).format('dddd, hh:mm A') }}
                                                </td>
                                                <td>{{ appointment.doctor.salutation }} {{ appointment.doctor.name }}
                                                </td>
                                                <td>
                                                    <v-chip small>
                                                        {{ appointment.type }}
                                                    </v-chip>
                                                </td>
                                                <td>
                                                    <v-chip small>
                                                        <template v-if="appointment.status == 0">Pending</template>
                                                        <template v-if="appointment.status == 1">Approved</template>
                                                        <template v-if="appointment.status == 2">Rejected</template>
                                                        <template v-if="appointment.status == 3">Cancelled</template>
                                                        <template v-if="appointment.status == 4">Completed</template>                                                        
                                                    </v-chip>
                                                    
                                                </td>
                                            </tr>
                                            <tr v-if="!appointmentsList.length">
                                                <td colspan="5" class="text-center">
                                                    <div class="text-center my-6">
                                                        <v-icon large>mdi-alert</v-icon>
                                                        <br>
                                                        <h3 class="font-weight-regular">No Appointments Found</h3>
                                                        <div class="mt-8 d-flex justify-center align-center">
                                                            <v-btn small outlined
                                                            @click="goToWebsite('search-doctor?clinic=1', false)"
                                                                > New Clinic Appointment

                                                            </v-btn>
                                                            <h5 class="mx-4">OR</h5>
                                                            <v-btn small outlined
                                                            @click="goToWebsite('search-doctor?video=1', false)"                                                            
                                                                > New Video Consultation
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                        <div v-if="loadingAppointments" class="py-12 text-center d-flex justify-center">
                                            <v-progress-circular
                                                    :size="50"
                                                    :width="5"
                                                    color="primary"
                                                    indeterminate
                                            ></v-progress-circular>
                                        </div>
                                    <v-pagination
                                            color="darkPrimary"
                                            @input="getAppointments"
                                            v-model="page"
                                            :length="appointmentPaginationDetails.last_page"
                                            v-if="appointmentPaginationDetails.total > filters.limit"
                                    ></v-pagination>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!--                    Mobile List UI-->
                    <v-row class="hidden-md-and-up">
                        <v-col cols="12" class="pt-0">
                            <v-row class="pb-0" dense>
                                <v-col cols="6" sm="12" md="5" class="pb-0">
                                    <v-select hide-details v-model="appointmentFilter" solo flat class="solo-bordered"                                        
                                              :items="appointmentFilters"
                                              item-text="text"
                                              item-color="darkPrimary"
                                              item-value="value"></v-select>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="6" sm="12" md="5" class="pb-0">
                                    <v-text-field hide-details label="Search" solo flat class="solo-bordered"
                                    v-model="search"
                                                  prepend-inner-icon="mdi-magnify"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                            <v-list three-line v-if="!loadingAppointments && appointmentsList.length">
                                <v-list-item-group>
                                    <v-divider></v-divider>
                                    <template v-for="appointment in appointmentsList">
                                        
                                        <v-list-item  
                                        :key="appointment.id" 
                                        @click="showAppointmentDetails(appointment)" 
                                        
                                        >
                                            <v-list-item-avatar color="grey lighten-2" tile>

                                                {{ dateutils.utcToLocal(appointment.start_time).format('DD') }}
                                                {{ dateutils.utcToLocal(appointment.start_time).format('MMM') }}
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ dateutils.utcToLocal(appointment.start_time).format('dddd, hh:mm A') }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{ appointment.doctor.salutation }} {{appointment.doctor.name }}
                                                </v-list-item-subtitle>
                                                 
                                                <v-list-item-subtitle v-if="appointment.type === 'online'">Online</v-list-item-subtitle>
                                                <v-list-item-subtitle v-else>Clinic</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-list-item-action-text>
                                                    <v-icon>mdi-chevron-right</v-icon>
                                                </v-list-item-action-text>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider :key="appointment.id"></v-divider>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                            <div v-if="!loadingAppointments && appointmentsList.length" class="pt-3">
                                
                                <v-pagination
                                        color="darkPrimary"
                                        @input="getAppointments"
                                        v-model="page"
                                        :length="appointmentPaginationDetails.last_page"
                                        v-if="appointmentPaginationDetails.total > filters.limit"
                                ></v-pagination>
                            </div>
                            
                            <div v-if="loadingAppointments" class="py-12 text-center">
                                <v-progress-circular
                                        :size="50"
                                        :width="5"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </div>
                            <div v-if="!appointmentsList.length && !loadingAppointments" class="py-12 text-center">
                                <v-icon x-large>mdi-alert</v-icon>
                                <br>
                                <h3 class="font-weight-regular">No Appointments Found</h3>
                                <div class="mt-8 d-flex flex-column px-10">                                    
                                    <v-btn small outlined
                                    @click="goToWebsite('search-doctor?clinic=1', false)"
                                        > New Clinic Appointment

                                    </v-btn>
                                    <h6 class="my-2"> OR</h6>
                                    <v-btn small outlined
                                    @click="goToWebsite('search-doctor?video=1', false)"
                                    class=""
                                        > New Video Consultation
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <!--                Details-->
                <v-col cols="12" v-if="appointmentsList.length" sm="12" md="5" class="lightPinkBackground hidden-sm-and-down">
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <h2> Appointment Details</h2>
                            <br>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                            <appointment-details :appointmentDetailsProp="appointmentDetails"
                                                :key="appointmentDetails.id+'-web'"                            
                                                 @update-appointment="updateAppointment" 
                                                 :showActions="true"
                                                  v-if="appointmentDetails.doctor.name"></appointment-details>
                            <v-card flat tile v-else style="min-height: 50vh">
                                <v-card-text class="text-center">
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <v-icon x-large>mdi-alert</v-icon>
                                    <br>
                                    <h3 class="font-weight-regular">No Appointments Found</h3>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" sm="12" class="text-center">
                    <h1>
                        Please login to continue to your Dashboard
                    </h1>
                    <br>
                    <v-btn class="accent-gradient white--text" large @click="goToWebsite('patient-login', false)">
                        Login
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog 
            v-model="sheet"
            color="white"
            background="white"
            fullscreen
        >
            <v-toolbar
                    dark          
                    color="primary"
                >
                <v-btn
                    icon
                    dark
                    color="black"
                    @click="sheet = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="black--text"></v-toolbar-title>
                <v-spacer></v-spacer>
            
            </v-toolbar>
            <appointment-details 
            :key="appointmentDetails.id+'-mobile'"                                        
            :appointmentDetailsProp="appointmentDetails" 
            :show-actions="true"></appointment-details>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import AppointmentDetails from "../components/AppointmentDetails";
    
    var appointmentRequestToken;
    export default {
        name: "MyAppointments",
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo'
            ]),
        },
        components: {
            AppointmentDetails
        },
        mounted() {
            
            if(this.$route.params.appointmentId){             
                this.showDetail =true
                this.appointmentFilter = '';
                this.getAppointments()
                .then(()=>{                                                
                    this.getAppointmentDetails(this.$route.params.appointmentId)                
                })
                
            }
            else{
                this.getAppointments();
            }
                        
        },
        methods: {
            isConfirmCancelButtonDisabled(){
                console.log("BTN DISABLED")
                console.log((this.cancelDetails.selected_reason))
                if(!this.cancelDetails.selected_reason)
                    return true
                else if(this.cancelDetails.selected_reason.action == 'other' && !this.cancelDetails.other_reason)
                    return true
                else 
                    return false
            },
            getCancellationReasons(){
                this.cancelDetails.loading = true
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/cancel-reasons`)
                    .then((response) => {
                        if (response.data.status === 1) {
                            this.cancelDetails.reasons = response.data.data                            
                        }
                    })
                    .catch(() => {

                    })
                    .finally(() => {
                        this.cancelDetails.loading = false
                    })
            },
            showAppointmentDetails(appointment) {
                
                this.appointmentDetails = appointment;
                this.sheet = true;
            },
            gotoVideo(appointment) {
                this.$router.push({
                    name: 'appointmentCall', params: {
                        appointmentId: appointment.id
                    }
                })
            },
            resetAppointments(){
                this.page = 1;
                this.getAppointments()
            },
            getAppointments: function () {
                if (!this.userInfo) {
                    return;
                }
                this.loadingAppointments = true;
                this.filters.page = this.page;
                this.filters.search = this.search
                if(this.appointmentFilter == "upcoming" || this.appointmentFilter == "past"){
                    let now = this.moment().format('YYYY-MM-DD HH:mm:ss');                    
                    var filter_date = this.dateutils.toUtcString(now)
                    
                    this.filters.filter_date = filter_date                    
                }
                this.filters.filter_type = this.appointmentFilter

                if(appointmentRequestToken)
                    appointmentRequestToken.cancel("New Request")
                appointmentRequestToken = this.axios.CancelToken.source();
                return new Promise((resolve) => {
                    this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/patient/` + this.userInfo.id, {
                                    params: this.filters                    
                    },{
                        cancelToken : appointmentRequestToken
                    }).then((response) => {
                        if (response.data.status === 1) {
                            this.appointmentPaginationDetails = response.data.data;
                            this.appointmentsList = this.appointmentPaginationDetails.data;

                            if (this.appointmentsList.length && !this.showDetail) {
                                this.appointmentDetails = this.appointmentsList[0];
                            }
                        }
                        this.loadingAppointments = false;
                    }).catch((error) => {
                        console.log(error);
                        this.loadingAppointments = false;
                    }).finally(() => {                      
                        resolve()
                    })
                })
               
            },
                                   
            updateAppointment:function(event, appointment){
                console.log("UPDATE APPOINTMENT CALLED")
                console.log(appointment)
                var index = this.appointmentsList.indexOf(this.appointmentDetails)
                this.appointmentsList.splice(index, 1, appointment)                
            },
            getAppointmentDetails(appointmentId){                
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/` + appointmentId)
                .then((response) => {
                    if (response.data.status === 1) {
                        this.appointmentDetails = response.data.data                                                                                             
                    }
                    this.showDetail = false
                    
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
                })
            }
        },
        data: () => ({
            sheet: false,
            filters: {
                filter_type:'',
                formatType: 'paginate',
                limit: 6,
                search:"",
            },
            appointmentPaginationDetails: {},
            page: 1,
            loadingAppointments: false,
            appointmentsList: [],
            appointmentFilter: 'upcoming',            
            appointmentFilters: [
                {
                    text:'All Appointments',
                    value:'',
                },
                {
                    text:'Upcoming Appointments',
                    value:'upcoming',
                },
                {
                    text:'Past Appointments',
                    value:'past',
                }                
            ],
            appointmentDetails: {
                patient: {},
                doctor: {},
                clinic: {}
            },
            selectedAppointment: {
                doctor: {
                    name: null
                }
            },            
            cancelAppointmentLoading:false,
            cancelAppointmentId:null,
            showDetail:false,
            search:"",
            cancelDetails:{
                showDialog:false,
                loading:false,
                selected_reason:null,
                reasons:[],
                note:"",
                other_reason:"",
                description:""
            },
        }),
        watch:{
            appointmentFilter(){
                this.resetAppointments()
            },
            search(){
                this.resetAppointments()
            }
        }
    }
</script>

<style>
    .banner-cards {
        border: 1px solid #e9c68e !important;
    }

    .banner-cards .card__actions {
        padding: 4px 8px !important;
    }

    .solo-bordered .v-input__slot {
        border: 1px solid #ccc;
    }
</style>